<template>

    <div class="overview-title" style="margin-top: 0px; justify-content: space-between; display: flex; padding: 8px 16px; box-shadow: rgba(0, 0, 0, 0.03) 0px 8px 15px inset;">
        <span class="overview--sub-title roboto f16 bold--text">{{ $t("plan_calculator.discount") }}</span>
        <div style="flex-grow: 1;"></div>

        <pm-price v-if="$store.state.simplePlan.discountMode === 'currency'" class="black--text roboto bold--text f16 pm-price" :value="calculateDiscount()" />

        <span v-else class="black--text roboto bold--text f16 pm-price" style="white-space: nowrap;">
            {{ $store.state.simplePlan.discountAmount }}
            <small>&nbsp;%</small>
        </span>
    </div>
</template>
<script>
import { getFullTotal, calculateDiscount } from "./plan";
import { getCurrencySettings, getCurrencySymbol } from '@/utils/currency';

export default {
    methods: {
        getFullTotal() {
            return getFullTotal();
        },
        calculateDiscount() {
            return calculateDiscount();
        },
    },
}
</script>
